module.exports = __webpack_public_path__ + "static/littleWomen5s-20adb4cb5f9a17dc68065d23c9c5c032.jpg";